// extracted by mini-css-extract-plugin
export default {"statusBar":"statusBar_statusBar__LTAsK","prevBtnArea":"statusBar_prevBtnArea__tg3bU"};